export default __webpack_public_path__ + "static/media/angle-left-solid-full.18fb1604.svg";